/**
 * Set default values for future ajax requests.
 */
$(function () {
    $.ajaxSetup({
        beforeSend: function (jqXHR, settings) {

            // If the option loadingOverlay is set to true, then an overlay with a loading icon is shown over the whole page.
            // While the ajax request is not completed (success or error), nothing is clickable on the page.
            if (this.loadingOverlay !== undefined && this.loadingOverlay === true || settings.loadingOverlay !== undefined && settings.loadingOverlay === true) {
                this.overlayId = Math.ceil(Math.random() * Number.MAX_SAFE_INTEGER);
                $('body').prepend('<div id="overlay' + this.overlayId + '" class="ajax-overlay"><div class="ajax-outer"><div class="ajax-middle"><div class="ajax-inner updateLoaderIcon"></div></div></div></div>');
            }
            jqXHR.url = settings.url;
        },
        complete: function (jqXHR, textStatus) {
            // Removes the overlay with the loading icon
            if ((this.loadingOverlay !== undefined && this.loadingOverlay === true) || (typeof settings !== "undefined" && settings.loadingOverlay !== undefined && settings.loadingOverlay === true)) {
                $('#overlay' + this.overlayId).remove();
            }
        },
        error: function (x, status, error) {

            // The error function in ajaxSetup is called whenever an ajax call fails. If an ajax call fails, the whole content of the current page is overwritten with the error response.
            // It is necessary because some ajax calls in the ES3 doesn't show any response to the user while an error occurs.
            if (typeof x.responseText === 'undefined' || this.disablePageReplace) {
                // we have no bug, please go away.
                return;
            }
            var newDoc = document.open("text/html", "replace");
            newDoc.write(x.responseText);
            newDoc.close();
        }
    });
});